/**
 * TransactionPage.tsx
 * @description :: This page displays the Coins and Cash history of members
 */
import React, { useEffect, useState } from "react";
import {
  Table,
  ScrollArea,
  rem,
  Text,
  UnstyledButton,
  Center,
  Select,
  Checkbox,
  Pagination,
  Tabs,
} from "@mantine/core";
import {
  IconSelector,
  IconChevronDown,
  IconChevronUp,
  IconCircleMinus,
  IconCirclePlus,
} from "@tabler/icons-react";
// import DeleteModal from "./DeleteModal";
// import AddTransModal from "./AddTransModal";
// import EditTransModal from "./EditTransModal";
import classes from "../TransactionPage/transaction.module.css";
import { RowDataTransaction } from "./types";
import { useFetchRowData } from "../hooks/useFetchRowData";
import { transaction } from "../types/RowDataTypes";
import { SearchBar } from "../SearchBar/SearchBar";
import useAxiosPrivate from "../../auth/useAxiosPrivate";
// import { showErrorAlert, showSuccessAlert } from "../../helper/alerts";
import Header from "../static/Header";
import { useLocation, useNavigate } from "react-router-dom";
import getTransactionTable, { TransactionTypes } from "../../DataDisplay/DataDisplayTable/TransactionTable";
import AllTab, { colFilterAll } from "../../DataDisplay/DataDisplayTab/TransactionTab/Tabs/AllTab";
import CoinsTab, { colFilterCoins, colFiltersCoins } from "../../DataDisplay/DataDisplayTab/TransactionTab/Tabs/CoinsTab";
import CashTab, { colFilterCash } from "../../DataDisplay/DataDisplayTab/TransactionTab/Tabs/CashTab";
import TransactionDisplayTab from "../../DataDisplay/DataDisplayTab/TransactionTab/TransactionDisplayTab";
// import TabI from "../../DataDisplay/DataDisplayTab/TabI";
// import DataDisplayTabI from "../../DataDisplay/DataDisplayTabI";
import ScoreCard from "./ScoreCard";
import { showErrorAlert } from "../../helper/alerts";

export interface ThProps {
  children: React.ReactNode;
  sortable: boolean;
  reversed: boolean;
  sorted: boolean;
  onSort(): void;
}

function Th({ children, sortable, reversed, sorted, onSort }: ThProps) {
  const Icon = sorted
    ? reversed
      ? IconChevronUp
      : IconChevronDown
    : IconSelector;
  let allowedSorts: any;
  if (window.location.href.split("/")[4] === "all")
    allowedSorts = [
      colFilterAll.TYPE.toLowerCase(),
      colFilterAll.COINS.toLowerCase(),
      colFilterAll.CASH.toLowerCase(),
      colFilterAll.CREATED.toLowerCase(),
    ];
  else if (window.location.href.split("/")[4] === "cash")
    allowedSorts = [
      colFilterCash.TYPE.toLowerCase(),
      colFilterCash.CASH.toLowerCase(),
      colFilterCash.CREATED.toLowerCase(),
    ];
  else if (window.location.href.split("/")[4] === "coins")
    allowedSorts = [
      colFilterCoins.TYPE.toLowerCase(),
      colFilterCoins.COINS.toLowerCase(),
      colFilterCoins.CREATED.toLowerCase(),
    ];

  return (
    <Table.Th className={`${classes.th} ${sortable ? classes.sortable : ""}`}>
      {allowedSorts!!.includes(children!!.toString().toLowerCase()) ? (
        <UnstyledButton onClick={onSort} className={classes.control}>
          <div className={classes.sortableHeader}>
            <Text className={classes.Text}>{children}</Text>
            <Center className={classes.icon}>
              <Icon style={{ width: rem(16), height: rem(16) }} stroke={1.5} />
            </Center>
          </div>
        </UnstyledButton>
      ) : (
        <Text fw={500} fz="sm">
          {children}
        </Text>
      )}
    </Table.Th>
  );
}

const initialData: RowDataTransaction[] = [
  {
    transaction_id: "",
    fullname: "",
    coins: "",
    type: "",
    remark: "",
    created_at: "",
  },
];

export function TransactionPage() {
  const axiosPrivate = useAxiosPrivate();

  const [search, setSearch] = useState("");
  // const [tableData, setTableData] = useState(initialData);
  const [sortBy, setSortBy] = useState<keyof RowDataTransaction | null>(null);
  const [reverseSortDirection, setReverseSortDirection] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage, setItemsPerPage] = useState(10);
  const [vouchersToday, setVouchersToday] = useState(0);
  const [vouchersThisMth, setVouchersThisMth] = useState(0);

  // Used in searching and when deleting to cause rerender to fetch data
  const [tableStateChanged, setTableStateChanged] = useState(0);

  const changeTableState = () => {
    setTableStateChanged(Math.random() * Math.random());
  };

  //For Searching
  // const colHeaders = ["Transaction ID", "Fullname", "Type", "Remark", "Coins"];
  const [selectedFilters, setSelectedFilters] = useState<string[]>([]);
  function resetPage() {
    if (currentPage !== 1) {
      setCurrentPage(1);
      return true;
    }
    return false;
  }

  const checkboxesFilter: JSX.Element[] = [];

  //Set allowed search filter checkbox to be shown
  const allowedFilters = [
    colFiltersCoins[colFilterCoins.TRANSACTION_ID],
    colFiltersCoins[colFilterCoins.FULLNAME],
  ];

  if (window.location.href.split("/")[4] === "coins" || window.location.href.split("/")[4] === "cash")
    allowedFilters.push(colFiltersCoins[colFilterCoins.REMARK])

  for (const [key, value] of Object.entries(colFiltersCoins)) {
    if (allowedFilters.includes(value)) {
      const checkboxFilter: JSX.Element = (
        <Checkbox value={value} label={key} />
      );
      checkboxesFilter.push(checkboxFilter);
    }
  }

  const [showFilterOptions, setShowFilterOptions] = useState(false);

  const handleSearch = (event: React.ChangeEvent<HTMLInputElement>) => {
    const input = event.target.value;
    setSearch(input);
  };

  const location = useLocation();

  const currentDateMY = new Date(
    new Date().toLocaleString("en-US", { timeZone: "Asia/Kuala_Lumpur" })
  );

  // const fetchedData = useFetchRowDataTransaction(itemsPerPage, currentPage)

  // let dataDisplayTable: DataDisplayTable
  const transactionType = location.pathname.split("/")[2]

  // switch (transactionType) {
  //   case "all":
  //     dataDisplayTable = getAllTransactionTable()
  //     break;
  //   case "cash":
  //     dataDisplayTable = getCashTransactionTable()
  //     break;
  //   case "coins":
  //     dataDisplayTable = getCoinsTransactionTable()
  //     break;
  //   default:
  //     break;
  // }

  const fetchedData = useFetchRowData(
    itemsPerPage,
    currentPage,
    search,
    selectedFilters,
    tableStateChanged,
    sortBy ?? "createdAt",
    reverseSortDirection ? "DESC" : "ASC",
    transaction,
    getTransactionTable().create(transactionType as keyof typeof TransactionTypes)!!,
  );

  const totalRows = fetchedData.totalRows;
  const rowData: RowDataTransaction[] | null =
    fetchedData.data as RowDataTransaction[];

  const isLoading: boolean = fetchedData.isLoading;

  // const [isAddTransModalOpen, setAddTransModalOpen] = useState(false);
  // const [isEditTransModalOpen, setEditTransModalOpen] = useState(false);
  // const [selectedRowForEdit, setSelectedRowForEdit] =
  //   useState<RowDataTransaction | null>(null);

  const [rowDataTransaction, setRowDataTransaction] = useState<
    RowDataTransaction[] | null
  >(null);

  const setVoucherScoreCard = () => {
    axiosPrivate
      .post("/api/admin/vouchers/get-voucher-stats", {
        currentDate: currentDateMY.toISOString().slice(0, 10),
      })
      .then((response) => {
        setVouchersToday(response.data.voucherCountToday);
        setVouchersThisMth(response.data.voucherCountThisMonth)
      })
      .catch((err) => {
        showErrorAlert(err)
      });
  }

  useEffect(() => {
    setRowDataTransaction(rowData);
    setVoucherScoreCard();
  }, [rowData]);

  // const [isDeleteConfirmationOpen, setDeleteConfirmationOpen] = useState(false);
  // const [selectedRowToDelete, setSelectedRowToDelete] =
  //   useState<RowDataTransaction | null>(null);

  // const handleAddTrans = () => {
  //   setAddTransModalOpen(true);
  // };

  // const handleAddTransModalClose = () => {
  //   setAddTransModalOpen(false);
  // };

  // const handleAddTransSuccess = (newTransData: RowDataTransaction) => {
  //   setTableData([...tableData, newTransData]);
  // };

  // const handleEdit = (row: RowDataTransaction) => {
  //   setSelectedRowForEdit(row);
  //   setEditTransModalOpen(true);
  // };

  // const handleEditTransSuccess = (editedTransData: RowDataTransaction) => {
  //   axiosPrivate
  //     .post(
  //       "/api/admin/coins/update",
  //       {
  //         id: editedTransData.transaction_id,
  //         remarks: editedTransData.remark,
  //         type: editedTransData.type,
  //       },
  //       {
  //         headers: {
  //           "Content-Type": "multipart/form-data",
  //         },
  //       }
  //     )
  //     .then((response) => {
  //       const indexOfSelectedRow = rowDataTransaction!!.findIndex(
  //         (row) => row === selectedRowForEdit
  //       );
  //       const updatedData = [...rowDataTransaction!!];
  //       updatedData[indexOfSelectedRow] = {
  //         ...selectedRowForEdit!!,
  //         remark: editedTransData.remark,
  //         type: editedTransData.type,
  //       };
  //       setRowDataTransaction(updatedData);
  //       showSuccessAlert("Transaction Successfully Edited");
  //     })
  //     .catch((error) => {
  //       showErrorAlert("Something Went Wrong");
  //     });
  //   setEditTransModalOpen(false);
  // };

  // const handleDelete = (row: RowDataTransaction) => {
  //   setSelectedRowToDelete(row);
  //   setDeleteConfirmationOpen(true);
  // };

  // const handleDeleteConfirmed = () => {
  //   const indexToDelete = tableData.findIndex(
  //     (item) => item === selectedRowToDelete
  //   );

  //   if (indexToDelete !== -1) {
  //     const newData = [
  //       ...tableData.slice(0, indexToDelete),
  //       ...tableData.slice(indexToDelete + 1),
  //     ];
  //     setTableData(newData);
  //   }

  //   setDeleteConfirmationOpen(false);
  //   setSelectedRowToDelete(null);
  // };

  // const handleDeleteCancelled = () => {
  //   setDeleteConfirmationOpen(false);
  //   setSelectedRowToDelete(null);
  // };

  const setSorting = (field: keyof RowDataTransaction) => {
    const reversed = field === sortBy ? !reverseSortDirection : false;
    setReverseSortDirection(reversed);
    // console.log("is sorting")
    // console.log(field)
    setSortBy(field);
    changeTableState();
  };

  const startIndex = (currentPage - 1) * itemsPerPage;

  const handlePageChange = (newPage: number) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPageChange = (value: number) => {
    setCurrentPage(1);
    setItemsPerPage(value);
  };

  const rowsToMap = rowDataTransaction ?? [];
  const rows = rowsToMap.map((row, index) => (
    <Table.Tr key={index}>
      <Table.Td>{startIndex + index + 1}</Table.Td>
      <Table.Td style={{ width: "15%" }}>{row.transaction_id}</Table.Td>
      <Table.Td style={{ width: "15%" }}>{row.fullname}</Table.Td>
      <Table.Td style={{ width: "8%" }}>
        {row.type ? (
          <IconCirclePlus className={classes.typeIconPlus} />
        ) : (
          <IconCircleMinus className={classes.typeIconMinus} />
        )}
      </Table.Td>
      <Table.Td style={{ width: "8%" }}>{row.coins}</Table.Td>
      {location.pathname.split("/")[2] === "all" ? <Table.Td style={{ width: "8%" }}>{row.cash}</Table.Td> : <></>}
      <Table.Td style={{ width: "10%" }}>
        {new Date(row.created_at).toLocaleString("en-MY", {
          timeZone: "Asia/Kuala_Lumpur",
        })}
      </Table.Td>

      <Table.Td style={{ width: "20%" }}>{row.remark}</Table.Td>
      {/* <Table.Td className={classes.actionButtons} style={{ width: "100%" }}>
        <button onClick={() => handleEdit(row)} className={classes.editbutton}>
          <IconEdit /> Edit
        </button>

        <button
          onClick={() => handleDelete(row)}
          className={classes.trashbutton}
        >
          <IconTrash /> Delete
        </button>
      </Table.Td> */}
    </Table.Tr>
  ));

  const handleSelectPage = (selectedPage: number) => {
    if (selectedPage != currentPage) setCurrentPage(selectedPage);
  };
  const nav = useNavigate();
  const handleTabChange = (val: string | null) => {
    val = val ?? "current";
    nav(`/transaction-history/${val}`);
    if (currentPage !== 1)
      setCurrentPage(1);
    else
      changeTableState()
  };

  const displayTab: TransactionDisplayTab = new TransactionDisplayTab(reverseSortDirection, sortBy, setSorting, classes, Th, rowDataTransaction, rows)
  const tabs: TransactionTypes[] = [TransactionTypes.ALL, TransactionTypes.CASH, TransactionTypes.COINS]

  return (
    <div className={classes.transactionPageContainer}>
      <ScrollArea className={classes.parentContainer}>
        <Header title="Transaction History" />
        <div className={classes.searchAndAddContainer}>
          <div style={{ flex: 1 }}>
            <SearchBar
              isLoading={isLoading}
              resetPage={resetPage}
              changeTableState={changeTableState}
              search={search}
              handleSearch={handleSearch}
              setShowFilterOptions={setShowFilterOptions}
              showFilterOptions={showFilterOptions}
              selectedFilters={selectedFilters}
              setSelectedFilters={setSelectedFilters}
              checkboxesFilter={checkboxesFilter}
            />
          </div>
          <div className={classes.scoreCardRow}>
            <ScoreCard 
              score={isLoading? "-" : vouchersToday} 
              title={`Voucher Redemptions (Today, ${currentDateMY.toLocaleDateString("en-GB")})`}/>
            <ScoreCard 
              score={isLoading? "-" : vouchersThisMth} 
              title={`Total Vouchers Redeemed (${currentDateMY.toLocaleString("en-GB", {month: "long", year: "numeric"})})`}/>
          </div>
        </div>
        {/* <AddTransModal
          isOpen={isAddTransModalOpen}
          onClose={handleAddTransModalClose}
          onAddTrans={handleAddTransSuccess}
        /> */}

        {/* <EditTransModal
          isOpen={isEditTransModalOpen}
          onClose={() => setEditTransModalOpen(false)}
          onEditTrans={handleEditTransSuccess}
          transData={selectedRowForEdit || initialData[0]}
        /> */}

        {/* <DeleteModal
          isOpen={isDeleteConfirmationOpen}
          onClose={handleDeleteCancelled}
          onConfirm={handleDeleteConfirmed}
        /> */}

        <ScrollArea
          w={
            window.innerWidth -
            document.getElementById("nav-bar")!!.getBoundingClientRect().width
          }
        >
          <div className={classes.tabsContainer}>
            <Tabs
              defaultValue="coins"
              color="blueviolet"
              variant="pills"
              onChange={(value) => {
                handleTabChange(value);
              }}
            >
              <Tabs.List className={classes.tabHeader}>
                <Tabs.Tab value={TransactionTypes.ALL} className={classes.tabTitle}>
                  All
                </Tabs.Tab>
                <Tabs.Tab value={TransactionTypes.COINS} className={classes.tabTitle}>
                  Coins
                </Tabs.Tab>
                <Tabs.Tab value={TransactionTypes.CASH} className={classes.tabTitle}>
                  Cash
                </Tabs.Tab>
              </Tabs.List>

              {
                tabs.map(tab => {
                  return displayTab.createTab(tab)
                })
              }
            </Tabs>
          </div>
        </ScrollArea>

        <div className={classes.paginationContainer}>
          <div className={classes.resultCount}>
            <Text>
              {`Showing `}
              <span style={{ fontWeight: "bold" }}>{startIndex + 1}</span>
              {`-`}
              <span style={{ fontWeight: "bold" }}>
                {Math.min(currentPage * itemsPerPage, totalRows)}
              </span>
              {` of `}
              <span style={{ fontWeight: "bold" }}>{totalRows}</span>
              {` results`}
            </Text>
          </div>

          <div className={classes.rightContainer}>
            <div className={classes.rowsPerPageSelector}>
              <Select
                placeholder="Rows per page"
                data={["10", "20", "50"]}
                value={itemsPerPage.toString()}
                onChange={(value) =>
                  handleRowsPerPageChange(parseInt(value as string, 10))
                }
              />
            </div>

            <div className={classes.paginationSelector}>
              <Pagination
                color="blueviolet"
                value={currentPage}
                total={Math.ceil(totalRows / itemsPerPage)}
                onNextPage={() => handlePageChange(currentPage + 1)}
                onPreviousPage={() => handlePageChange(currentPage - 1)}
                onChange={(value: number) => handleSelectPage(value)}
              />
            </div>
          </div>
        </div>
      </ScrollArea>
    </div>
  );
}

export default TransactionPage;
